import { MdOutlineDeliveryDining, MdRestaurantMenu } from "react-icons/md";
import { TbCalendarMonth, TbDeviceMobileCheck, TbShoppingBag, TbLayoutDashboard } from "react-icons/tb";

export const ORDER_TYPE_DELIVERY_ID = 1;
export const ORDER_TYPE_TAKEAWAY_ID = 2;
export const ORDER_TYPE_DINE_IN_ID = 3;
export const ORDER_TYPE_SCHEDULING_ID = 4;
export const ORDER_TYPE_STORE_COUNTER_ID = 5;
export const ORDER_TYPE_MENU_ID = ORDER_TYPE_STORE_COUNTER_ID;

export const ORDER_TYPE_DELIVERY = 'delivery';
export const ORDER_TYPE_TAKEAWAY = 'takeaway';
export const ORDER_TYPE_DINE_IN = 'dine_in';
export const ORDER_TYPE_SCHEDULING = 'scheduling';
export const ORDER_TYPE_STORE_COUNTER = 'store_counter';
export const ORDER_TYPE_MENU = 'menu';

export let LABEL_DELIVERY = 'Delivery';
export let LABEL_TAKEAWAY = 'Para levar';
export let LABEL_DINE_IN = 'Papa-fila';
export let LABEL_SCHEDULING = 'Encomenda';
export let LABEL_STORE_COUNTER = 'Comanda';
export let LABEL_MENU = 'Menu';

export const updateServiceLabels = (company: any) => {
  const nomenclature = company?.config?.services_nomenclature || {};
  LABEL_DELIVERY = nomenclature.delivery || LABEL_DELIVERY;
  LABEL_TAKEAWAY = nomenclature.takeaway || LABEL_TAKEAWAY;
  LABEL_DINE_IN = nomenclature.dinein || LABEL_DINE_IN;
  LABEL_SCHEDULING = nomenclature.scheduling || LABEL_SCHEDULING;
  LABEL_STORE_COUNTER = nomenclature.store_counter || LABEL_STORE_COUNTER;
  LABEL_MENU = nomenclature.menu || LABEL_MENU;;
};


// Define getters dinâmicos — refletem sempre os valores atuais das labels
export const ORDER_TYPE_LABELS = {} as Record<string, string>;

Object.defineProperties(ORDER_TYPE_LABELS, {
  delivery: {
    get: () => LABEL_DELIVERY,
  },
  takeaway: {
    get: () => LABEL_TAKEAWAY,
  },
  dine_in: {
    get: () => LABEL_DINE_IN,
  },
  scheduling: {
    get: () => LABEL_SCHEDULING,
  },
  store_counter: {
    get: () => LABEL_STORE_COUNTER,
  },
  menu: {
    get: () => LABEL_MENU,
  },
});

export const ORDER_TYPE_ICONS = {
    delivery: MdOutlineDeliveryDining,
    takeaway: TbShoppingBag,
    dine_in: MdRestaurantMenu,
    scheduling: TbCalendarMonth,
    store_counter: TbDeviceMobileCheck,
    menu: TbLayoutDashboard,
};
export const ORDER_TYPE_ICONS_BY_ID = {
    [ORDER_TYPE_DELIVERY_ID]: MdOutlineDeliveryDining,
    [ORDER_TYPE_TAKEAWAY_ID]: TbShoppingBag,
    [ORDER_TYPE_DINE_IN_ID]: MdRestaurantMenu,
    [ORDER_TYPE_SCHEDULING_ID]: TbCalendarMonth,
    [ORDER_TYPE_STORE_COUNTER_ID]: TbDeviceMobileCheck
};